// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2zjqN","header":"ReportDetails_header__10P8n","title":"ReportDetails_title__2XU07","left":"ReportDetails_left__31DIx"};